<template>
  <div class="flex items-start space-x-3">
    <div class="flex-shrink-0">
      <div
        class="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center"
      >
        <span class="text-xs font-medium text-gray-600">{{
          activity.user.initials
        }}</span>
      </div>
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-sm text-gray-900">
        <span class="font-medium">{{ activity.user.name }}</span>
        {{ activity.action }}
        <span v-if="activity.target" class="text-blue-600">{{
          activity.target
        }}</span>
      </p>
      <p class="text-xs text-gray-500">{{ activity.time }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityItem",
  props: {
    activity: {
      type: Object,
      required: true,
      validator: activity => {
        return activity.user && activity.action && activity.time;
      }
    }
  }
};
</script>

<style scoped>
/* Component specific styles */
</style>
